export default "__VITE_ASSET__BVTNxLgW__"